import { getDateInFormat } from "@domains/utils/reportDates";
export function dashboardMapper(data) {
    if (data) {
        const dashboardSummary = data.dashboardSummary.map((x) => {
            return Object.assign(Object.assign({}, x), { investmentValue: x.investmentValue.toString(), marketValue: x.marketValue.toString(), realisedGain: x.realisedGain.toString() });
        });
        const pnlDetails = data.pnLDetails.map((x) => {
            return {
                totalPnLChangePercent: x.totalPnLChangePercent,
                scripName: x.scripName,
                quantity: x.quantity,
                edelweissProductShortCode: x === null || x === void 0 ? void 0 : x.edelweissProductShortCode,
                longTermQuantity: x.longTermQuantity,
                averageBuyPrice: x.averageBuyPrice,
                averageSellPrice: x.averageSellPrice,
                investmentValue: x.investmentValue,
                sellValue: x.sellValue,
                marketValue: x.marketValue,
                unrealisedPnL: x.unrealisedPnL,
                unrealisedPnLChangePercent: x.unrealisedPnLChangePercent,
                unrealisedSellQuantity: x.unrealisedSellQuantity,
                unrealisedSellValue: x.unrealisedSellValue,
                unrealisedAvgSellPrice: x.unrealisedAvgSellPrice,
                realisedPnL: x.realisedPnL,
                realisedPnLChangePercent: x.realisedPnLChangePercent,
                totalPnL: String(x.totalPnL),
                closingQuantity: x.closingQuantity,
                unrealisedBuyQuantity: x.unrealisedBuyQuantity,
                unrealisedAvgBuyPrice: x.unrealisedAvgBuyPrice,
                unrealisedBuyValue: x.unrealisedBuyValue,
                unrealisedClosePrice: x.unrealisedClosePrice,
                unrealisedMarketValue: x.unrealisedMarketValue,
                realisedQuantity: x.realisedQuantity,
                realisedAvgBuyPrice: x.realisedAvgBuyPrice,
                realisedBuyValue: x.realisedBuyValue,
                realisedAvgSellPrice: x.realisedAvgSellPrice,
                realisedSellValue: x.realisedSellValue,
                scripIdentifier: x.scripIdentifier,
                quote: x.quote,
                filterFlags: x.filterFlags,
                sector: x.sector,
                corpAction: x.corpAction,
                corpActionDesc: x.corpActionDesc,
                corpActionType: x.corpActionType,
                expiryDate: getDateInFormat(x.expiryDate, "DD-MMM-YYYY"),
                expiryMonth: getDateInFormat(x.expiryDate, "MMM"),
                underlyingAsset: x.underlyingAsset,
                optionType: x.optionType,
                strikePrice: x.strikePrice,
                instrumentType: x.instrumentType,
                editable: x.filterFlags.editable,
                realisedPnl: false,
                unrealisedPnl: false,
                profit: x.filterFlags.profit,
                loss: x.filterFlags.loss,
                isUnrealisedPnL: Number(x.unrealisedBuyQuantity) !== 0 ||
                    Number(x.unrealisedSellQuantity) !== 0
                    ? true
                    : false,
                isRealisedPnL: Number(x.realisedQuantity) !== 0 ? true : false,
                displayName: x.quote.displayName,
                dayChange: x.dayChange.toString(),
                assetClassId: x.assetClassId,
                edelweissProduct: x.edelweissProduct,
                news: x.news,
                research: x.research,
                exchange: x.exchange,
                edelweissTabShortCode: x.edelweissTabShortCode,
                shortTermQuantity: x.shortTermQuantity,
                edelweissAsset: x.edelweissAsset,
                tenure: x.tenure,
                coupon: x.coupon,
                rating: x.rating,
                riskCategory: x.riskCategory,
                yields: x.yields,
                maturityDate: x.maturityDate,
                interestFrequency: x.interestFrequency,
                futureInterestEarning: x.futureInterestEarning,
                faceValue: x.faceValue,
                aum: x.aum,
                dividendIncome: x.dividendIncome,
                absoluteReturn: x.absoluteReturn,
                interestPaid: x.interestPaid,
                interestDue: x.interestDue,
                freeQnty: x.freeQnty,
                lockInQnty: x.lockInQnty,
                schemeType: x.schemeType,
                folioNumber: x.folioNumber,
                holdingType: x.holdingType,
                benchmark: x.benchmark,
                category: x.category,
                issuerName: x.issuerName,
                status: x.status,
                series: x.series,
                lockInFlag: x.lockInFlag,
            };
        });
        return {
            dashboardSummary,
            pnlDetail: pnlDetails,
            pnlSummary: Object.assign(Object.assign({}, data.pnLSummary), { editableCount: 0 }),
            pnlDataFlags: {
                isBodEnabled: data === null || data === void 0 ? void 0 : data.isBodEnabled,
                bodProcessInfoMessage: data === null || data === void 0 ? void 0 : data.bodProcessInfoMessage
            }
        };
    }
    else {
        return {
            dashboardSummary: [],
            pnlDetail: [],
            pnlSummary: {
                totalPnl: "0",
                totalPnlChangePercent: "0",
                realisedPnl: "0",
                realisedPnlChangePercent: "0",
                unrealisedPnl: "0",
                unrealisedPnlChangePercent: "0",
                closePriceDate: "",
                totalMarketValue: "0",
                totalClosingCostValue: "0",
                totalSellCostValue: "0",
                totalSellValue: "0",
                totalInvestment: "0",
                daysPnLChange: "0",
                daysPnLChangePercent: "0",
                editableCount: 0,
            },
            pnlDataFlags: pnlDataFlagsInit
        };
    }
}
export const pnlDataFlagsInit = {
    bodProcessInfoMessage: "", isBodEnabled: false
};
